import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { getTheme } from "Theme";
import { FloatingBackButton } from "globalComponents";

const theme = getTheme();

const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px;
`;
const Title = styled.h1`
  font-size: 4em;
  color: ${theme.MAIN_COLOR};
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 32px;
`;

const SectionTitle = styled.h2`
  font-size: 2em;
  margin-bottom: 12px;
`;

const Paragraph = styled.p`
  font-size: 1.2em;
  color: #333;
  margin-bottom: 12px;
`;

const StyledList = styled.ul`
  font-size: 1.1em;
  color: #333;
  margin-left: 24px;
  margin-bottom: 12px;
  list-style-type: disc;
`;

const StyledDate = styled.div`
  font-size: 1em;
  color: #666;
  text-align: center;
  margin-bottom: 32px;
`;

const StyledLink = styled.a`
  color: ${theme.MAIN_COLOR};
  text-decoration: underline;
  &:hover {
    color: ${theme.SECONDARY_COLOR};
  }
`;

const CookiePolicy = () => {
  const history = useHistory();
  return (
    <Main>
      <FloatingBackButton onClick={() => history.push("/")}>
        Back
      </FloatingBackButton>
      <Title>Time Card Solutions Cookie Policy</Title>
      <StyledDate>Last updated July 23, 2025</StyledDate>
      <Section>
        <Paragraph>
          Time Card Solutions, LLC ("TCS") uses cookies and similar technologies
          to enhance your experience on our website and applications.
        </Paragraph>
      </Section>
      <Section>
        <SectionTitle>What Are Cookies?</SectionTitle>
        <Paragraph>
          Cookies are small text files stored on your device when you visit a
          website. They help us remember your preferences and improve your
          experience.
        </Paragraph>
      </Section>
      <Section>
        <SectionTitle>How We Use Cookies</SectionTitle>
        <StyledList>
          <li>
            <b>Login Information:</b> We use cookies to remember your login
            status and keep you signed in.
          </li>
          <li>
            <b>Application Data:</b> Cookies help us save your preferences and
            settings within the application.
          </li>
          <li>
            <b>Analytics:</b> We use Google Analytics cookies to understand how
            you use our site and improve our services.
          </li>
        </StyledList>
      </Section>
      <Section>
        <SectionTitle>Your Choices</SectionTitle>
        <Paragraph>
          You can manage or disable cookies in your browser settings. Please
          note that disabling cookies may affect your experience and some
          features may not work as intended.
        </Paragraph>
      </Section>
      <Section>
        <SectionTitle>Contact Us</SectionTitle>
        <Paragraph>
          If you have any questions about our cookie policy, please contact us
          at{" "}
          <StyledLink href="mailto:support@timecardsolutions.com">
            support@timecardsolutions.com
          </StyledLink>
          .
        </Paragraph>
      </Section>
    </Main>
  );
};

export default CookiePolicy;
